import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SalesStageList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.salesStage}`;

  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Description', value: 'description' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/sales-stage/details/${id}`;
  };

  return (
    <div>
      <h1>Sales Stages</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default SalesStageList;
